import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CardInfoType } from 'src/app/components/profile/profile.enum';
import { ProfileInfo } from 'src/app/interfaces/profile.interface';
import { CategoryType } from 'src/app/swagger-api';

@Component({
  selector: 'app-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss'],
})
export class ProfileInfoComponent implements OnChanges {
  @Input({ required: true }) public fields: ProfileInfo[];

  public infoType: typeof CardInfoType = CardInfoType;

  private categoryHints: Record<CategoryType, string> = {
    DISEASES: 'DISEASE',
    SPECIALTIES: 'SPECIALTIES',
    CHARITY_FOCUSES: 'CHARITY_FOCUSES',
  };

  public isCategoryList(field: ProfileInfo): boolean {
    for (const hint_type in this.categoryHints) {
      const hint = this.categoryHints[hint_type as CategoryType];

      if (field.hint?.includes(hint)) {
        return true;
      }
    }

    return false;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['fields']?.currentValue) {
      this.fields = this.fields.filter((item: ProfileInfo) => item.value['length'] > 0);
    }
  }
}
